import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
    adminUserBasePath
} from "../routes/routePaths";
import { useGetLoggedInUserDetails } from "../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { useTrackActivityFromPhaseOneAPIMutation } from "../reactQueries/commonRQHooks";


//using phase-1 track activity APi Needs to decommisioned whenever decided against pahse-2 API

// const sections = [
//     "User",
// ];
// const actionType = [
//     "Created",
//     "Updated",
//     "Downloaded",
//     "Uploaded",
//     "Viewed",
//     "Deleted",
//     "Recovred",
//     "Removed",
//     "EmailInvitationSent",
//      "Activated",
//      "Deactivated"
// ]


const useTrackUserActivityUsingPhaseOneAPI = () => {
    const { loggedInUser } = useGetLoggedInUserDetails();
    const { id: userId } = loggedInUser;

    const location = useLocation()
    const { pathname } = location


    /**geting functionality section */
    const [section, setSection] = useState("");

    const regExp_adminUserBasePath = new RegExp(adminUserBasePath, 'i')

    /**add new sections here for new functionality */
    useEffect(() => {
        if (pathname?.search(regExp_adminUserBasePath) !== -1) {
            setSection("User")
        }
    }, [pathname])


    /**add error messages for new action */
    const getErrorMsg = ({ actionType, itemId, extraDescription }) => {
        let errorMsg = "";

        if (actionType === "Created" ||
            actionType === "Updated" ||
            actionType === "Deleted" ||
            actionType === "Recovered" ||
            actionType === "Removed"
        ) {
            if (section === "User") {
                /**add admin roles in  "extraDescription" arg*/
                /**e.g. "ganesh as admin and coach" */
                const extraDescript = !!extraDescription ? `${extraDescription}` : ""
                errorMsg = `${actionType.toLowerCase()} ${extraDescript}`;
            } else {
                errorMsg = `Id: ${itemId} ${actionType.toLowerCase()}`;
            }
        }

        return errorMsg
    }

    const { mutate: trackActivityUsingPhaseOneAPI, isError: isErrorOnTrackActivity, isLoading: isLoadingOnTrackActivity, isSuccess: isSuccessOnTrackActivity, data: dataOnTrackActivity, error: errorOnTrackActivity } = useTrackActivityFromPhaseOneAPIMutation()

    const callUserActivity = ({ actionType, itemId, activitySuccess, extraDescription }) => {
        const errorMsg = getErrorMsg({ actionType, itemId, extraDescription });

        if (!!activitySuccess) {
            trackActivityUsingPhaseOneAPI({
                StaffId: userId || "",
                SourceId: itemId || "",
                Type: section || "",
                Value: errorMsg || "",

                TriggeredTimeStamp: new Date().toISOString(),
                CreatedBy: userId || "",
                CreatedTimeStamp: new Date().toISOString(),
                UpdatedBy: "",
                UpdatedTimeStamp: ""
            })
        }
    }
    return {
        trackActivityUsingPhaseOneAPI: callUserActivity
    }

}
export default useTrackUserActivityUsingPhaseOneAPI